import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { forwardRef, useEffect, useRef, useState } from 'react';
import CustomSelect2 from './CustomSelect2';
import { Box, Typography, FormControlLabel, Checkbox, TextField, InputAdornment, Select, MenuItem } from '@mui/material';
import SelectPlanCheckbox from './SelectPlanCheckbox';
import getSafe from '../utils/getSafe';
import PercentInput from './PercentInput';
import NotesDisplay from './NotesDisplay';
import RatesVersionSelect from './RatesVersionSelect';
import TableViewModeToggleButton from './TableViewModeToggleButton';
import CopyImageButton from './CopyImageButton';
import TableCellRate from './TableCellRate';
import TableCellText from './TableCellText';
import TableCellRateSubtotalPerPlan from './TableCellRateSubtotalPerPlan';
import _, { set } from 'lodash';
import CopyExcelDataButton from './CopyExcelDataButton';




const BHP_Indonesia_Rates = forwardRef(({ appConfig, sx, clients, currency, _currency, selectedPlans,
  setSelectedPlans, loadingStatus, response, setResponse, deductibles, setDeductibles,
  addToPendingTasks, discounts, setDiscounts, loadings, setLoadings, computedRates,
  setComputedRates, specificAreaOfCoverage, setSpecificAreaOfCoverage, areaOfCoverage,
  setShowImageCopy, selectedOptions, addSelectedOption,
  setViewSelectedOption, specificCurrency, setSpecificCurrency,
  specificPaymentFrequency, setSpecificPaymentFrequency,
  BHP_IndonesiaSpecific, setBHP_IndonesiaSpecific,
  isExpandedApiRequestPerInsurers, setIsxpandedApiRequestPerInsurers,
  tableOfBenefits, fetchTOB_Data , insurerRates = [], selectedRatesVersion, setSelectedRatesVersion, handleFetchAppConfig, setShowRefreshNow }, ref) => {

  const id = 'bhp_indonesia';

  // const { appConfig } = useContext(ConfigContext);

  const containerRef = useRef(null);


  const specific_area_of_coverages = getSafe(() => appConfig.content.bhp_indonesia_area_of_coverage);

  const currencies = getSafe(() => appConfig.content.currencies, []);

  const [withMaternity, setWithMaternity] = useState(false);
  const [copay, setCopay] = useState(appConfig.content.specifics[id]?.copay_options?.[0] || '');
  const [groupSize, setGroupSize] = useState(getGroupSizesOptions()?.length > 0 ? getGroupSizesOptions()?.[0] : '');

  const [addOnsPerClient, setAddOnsPerClient] = useState({});

  // const [assistanceCovers, setAssistanceCovers] = useState({
  //   evacuation: false,
  //   repatriation: false
  // });

  useEffect(() => {
    computedRates[id] = getComputedRates();
    setComputedRates(computedRates);
  }, [response, discounts, loadings]);

  // [TODO]
  useEffect(() => {
    setTimeout(() => {
      addSelectedOption(id, 'specific_area_of_coverage', specificAreaOfCoverage[id]);
      addSelectedOption(id, 'specific_currency', specificCurrency[id]);
      addSelectedOption(id, 'specific_payment_frequency', specificPaymentFrequency[id]);
      addSelectedOption(id, 'deductible', deductibles[id]);
      addSelectedOption(id, 'discount', discounts[id] == '' ? 0 : discounts[id]);
      addSelectedOption(id, 'loading', loadings[id] == '' ? 0 : loadings[id]);

      addSelectedOption(id, 'add_ons_per_client', JSON.stringify(addOnsPerClient));
      addSelectedOption(id, 'copay', copay);
      addSelectedOption(id, 'group_size', groupSize);
    }, 1000);

  }, [JSON.stringify(addOnsPerClient), copay, groupSize, specificAreaOfCoverage[id], specificCurrency[id], specificPaymentFrequency[id], deductibles[id], discounts[id], loadings[id]]);

  // [TODO]
  useEffect(() => {
    setViewSelectedOption(id, 'deductible', (option_value) => {
      deductibles[id] = option_value;
      setDeductibles(deductibles);
    });
    setViewSelectedOption(id, 'discount', (option_value) => {
      discounts[id] = option_value;
      setDiscounts(discounts);
    });

    setViewSelectedOption(id, 'loading', (option_value) => {
      loadings[id] = option_value;
      setDiscounts(loadings);

    });

    setViewSelectedOption(id, 'specific_area_of_coverage', (option_value) => {
      specificAreaOfCoverage[id] = option_value;
      setSpecificAreaOfCoverage(specificAreaOfCoverage);
      // console.log(specificAreaOfCoverage, option_value);
    });

    setViewSelectedOption(id, 'specific_currency', (option_value) => {
      specificCurrency[id] = option_value;
      setSpecificCurrency(specificCurrency);
      // console.log(option_value)
    });

    setViewSelectedOption(id, 'specific_payment_frequency', (option_value) => {
      specificPaymentFrequency[id] = option_value;
      setSpecificPaymentFrequency(specificPaymentFrequency);
    });

    // setViewSelectedOption(id, 'with_maternity', (option_value) => {
    //   let val = option_value === 'true' ? true : false;

    //   BHP_IndonesiaSpecific['with_maternity'] = val;
    //   setBHP_IndonesiaSpecific({ ...BHP_IndonesiaSpecific });

    //   setWithMaternity(val);
    // });

    setViewSelectedOption(id, 'add_ons_per_client', (option_value) => {
      setAddOnsPerClient(JSON.parse(option_value));
    });

    setViewSelectedOption(id, 'copay', (option_value) => {
      BHP_IndonesiaSpecific['copay'] = option_value;
      setBHP_IndonesiaSpecific({ ...BHP_IndonesiaSpecific });

      setCopay(option_value);
    });

    setViewSelectedOption(id, 'group_size', (option_value) => {
      BHP_IndonesiaSpecific['group_size'] = option_value;
      setBHP_IndonesiaSpecific({ ...BHP_IndonesiaSpecific });

      setGroupSize(option_value);
    });
  }, [selectedOptions]);


  // [TODO]
  function getComputedRates() {
    if (!response) return;

    const rates = response.rates;
    const discount = parseFloat(discounts[id]) || 0;
    const loading = parseFloat(loadings[id]) || 0;
    const totalPercent = ((100 - discount + loading) * 0.01);


    const computedRates = [];

    for (let i = 0; i < rates.length; i++) {
      const computedRate = {
        'client': rates[i].client,
        'currency': rates[i].currency,
        'select': rates[i].select * totalPercent,
        'premier': rates[i].premier * totalPercent,
        'premier_with_maternity': rates[i].premier_with_maternity * totalPercent,
        'elite': rates[i].elite * totalPercent,
        'elite_with_maternity': rates[i].elite_with_maternity * totalPercent,
        'ultimate': rates[i].ultimate * totalPercent,
        'ultimate_with_maternity': rates[i].ultimate_with_maternity * totalPercent,
        'dental_1': rates[i].dental_1 * totalPercent,
        'dental_optical_2': rates[i].dental_optical_2 * totalPercent,
        'dental_optical_3': rates[i].dental_optical_3 * totalPercent,
      };

      computedRates.push(computedRate)
    }

    return computedRates;
  }

  function handleDeductibleChange(e) {
    const _deductibles = JSON.parse(JSON.stringify(deductibles));

    _deductibles[id] = e.target.value;

    setDeductibles(_deductibles);

    // clearResponse();

    addToPendingTasks([id]);
  }


  function scrollToView() {
    // setTimeout(() => {
    //   containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // }, 200);
  }

  function clearResponse() {
    setResponse(prev => {
      return { ...prev, [id]: null };
    });
  }

  // const computedRatesMemo = useMemo(() => getComputedRates(), []);

  const getComputedRatesMemo = _.memoize(getComputedRates);

  function getRate(clientIndex, plan) {
    const computedRates = getComputedRatesMemo();

    if (!computedRates) {
      return;
    }

    if (specificCurrency[id] !== computedRates?.[clientIndex]?.currency) {
      return '-';
    }

    return computedRates?.[clientIndex]?.[plan];
  }

  function getSubTotalPerPlan(plan) {
    let subTotal = 0;

    if (!clients || clients.length === 0) {
      return 0;
    }

    clients.forEach((client, idx) => {

      let rate;

      if (checkAddOnPerClient('maternity', idx) && (plan === 'premier' || plan === 'elite' || plan === 'ultimate')) {
        rate = getRate(idx, plan + '_with_maternity');
      } else {
        rate = getRate(idx, plan);
      }

      if (!isNaN(rate)) {
        subTotal += rate;
      }

      
    });

    return subTotal;
  }

  function getRateForExpandedTable(clientIndex, deductible, plan) {
    const computedRates = getComputedRatesMemo();

    if (!computedRates) {
      return;
    }

    if (specificCurrency[id] !== computedRates?.[clientIndex]?.currency) {
      return '-';
    }

    return computedRates?.[clientIndex]?.rates_per_deductibles?.[deductible]?.[plan];
  }

  function getRateSubTotalForExpandedTable(deductible, plan) {
    const computedRates = getComputedRatesMemo();

    if (!computedRates) {
      return;
    }

    if (specificCurrency[id] !== computedRates?.[0]?.currency) {
      return '-';
    }

    let subTotal = 0;

    for (let i = 0; i < clients.length; i++) {
      const rate = computedRates?.[i]?.rates_per_deductibles?.[deductible]?.[plan];

      if (isNaN(rate)) {
        continue;
      }

      subTotal += rate;
    }

    return subTotal;
  }

  function getCurrency() {
    const computedRates = getComputedRatesMemo();

    if (!computedRates) {
      return;
    }

    if (computedRates.length > 0) {
      return computedRates[0].currency;
    }

    return 'USD';
  }

  function getColorForDeductible(index) {
    const colors = ['#f7f2de', '#f7fcff', '#ccdcc8', '#f7fcff', '#f7f2de', '#e0d095', '#f7f2de'];

    return colors[index % colors.length];
  }

  function getColorForDeductible1(index) {
    const colors = ['#dcd6d6', '#e1e6e9'];

    return colors[index % colors.length];
  }

  function getGroupSizesOptions() {
    const group_sizes = appConfig.content.specifics[id]?.group_sizes;

    if (!group_sizes) {
      return [];
    }

    return Object.keys(group_sizes);
  }

  function getDisplayValue(property) {
    const value = appConfig.content.specifics[id]?.group_sizes?.[groupSize]?.[property];

    if (!value) {
      return 'N/A';
    }

    if (isNaN(value)) {
      return value;
    }

    return value * 100 + '%';
  }

  function checkAddOnPerClient(addon, clientIdx) {
    const isChecked = addOnsPerClient[clientIdx]?.[addon];
    const client = clients[clientIdx];

    if (addon === 'maternity') {
      if (isChecked === undefined) {
        if (client.gender === 'Female' && client.age >= 18 && client.age <= 64) {
          return true;
        } else {
          return false;
        }
      } else {
        return isChecked;
      }

    } else if (addon === 'dental' || addon === 'optical') {
      if (isChecked === undefined) {
        return true;
      } else {
        return isChecked;
      }
    }

    return false;
  }

  function handleAddOnPerClientChange(addon, clientIdx) {
    const prevState = checkAddOnPerClient(addon, clientIdx);

    setAddOnsPerClient((prev) => ({
      ...prev,
      [clientIdx]: {
        ...prev[clientIdx],
        [addon]: !prevState,
      },
    }));
  }


  return (
    <Box id={id} sx={sx}>
      <Paper sx={{ borderColor: '#e0e0e0', borderWidth: 2, pb: 2, scrollMarginTop: '200px' }} variant='outlined' ref={containerRef}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#0c1b4e', px: 2, py: 1 }}>
          <div style={{
            color: '#fff',
            backgroundColor: '#0369ae',
            width: 100,
            height: 60,
            padding: 6,
            fontFamily: 'Poppins, sans-serif',
            fontSize: 13,
            lineHeight: 1.2,
          }}>Business Health Plans</div>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <img src={`${process.env.PUBLIC_URL}/images/Sunday Logo.png`} alt="Sunday Logo" style={{ height: 60, userSelect: 'none', WebkitUserDrag: 'none' }} draggable={false} onContextMenu={(e) => e.preventDefault()} />
            <img src={`${process.env.PUBLIC_URL}/images/BUPA Blue Logo.png`} alt="BUPA" style={{ height: 60, userSelect: 'none', WebkitUserDrag: 'none' }} draggable={false} onContextMenu={(e) => e.preventDefault()} />
          </Box>
        </Box>
        <Box sx={{ p: 2 }}>

          <Box sx={{ display: 'flex', gap: 5 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography fontSize={15} fontWeight={600}>Plan Type</Typography>
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='bhp_indonesia_select' />} label="Select" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='bhp_indonesia_premier' />} label="Premier" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='bhp_indonesia_elite' />} label="Elite" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='bhp_indonesia_ultimate' />} label="Ultimate" />


              {/* <FormControlLabel
                sx={{ mt: 3, color: '#1565c0' }}
                control={
                  <Checkbox
                    checked={withMaternity}
                    onChange={(e) => {
                      // setWithMaternity(e.target.checked);

                      // BHP_IndonesiaSpecific.with_maternity = e.target.checked;
                      // setBHP_IndonesiaSpecific({ ...BHP_IndonesiaSpecific });

                      // addToPendingTasks([id]);
                    }}
                  />
                }
                label="With Maternity"
              /> */}

              <Typography fontSize={15} fontWeight={600} sx={{ mt: 1.5 }}>Dental & Optical</Typography>
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='bhp_indonesia_dental_1' />} label="Dental 1" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='bhp_indonesia_dental_optical_2' />} label="Dental & Optical 2" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='bhp_indonesia_dental_optical_3' />} label="Dental & Optical 3" />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Deductible Option</Typography>
                <CustomSelect2
                  dense
                  value={deductibles[id]}
                  onChange={handleDeductibleChange}
                  items={appConfig.content.deductibles?.[id]?.[specificCurrency?.[id]]}
                  disabled={loadingStatus[id]}
                  sx={{ minWidth: 170 }}
                />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Copay Option</Typography>
                <Select
                  size='small'
                  value={copay}
                  onChange={(e) => {
                    setCopay(e.target.value);

                    BHP_IndonesiaSpecific.copay = e.target.value;
                    setBHP_IndonesiaSpecific({ ...BHP_IndonesiaSpecific });

                    // clearResponse();

                    addToPendingTasks([id]);
                  }}
                  sx={{ fontSize: 12, height: 32, width: '170px', minWidth: 170 }}
                  fullWidth
                  disabled={loadingStatus[id]}
                >
                  {
                    appConfig.content.specifics[id]?.copay_options?.map(copay => (
                      <MenuItem key={copay} value={copay} sx={{ fontSize: 12 }}>{copay}</MenuItem>
                    ))
                  }

                </Select>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Group Size</Typography>
                <Select
                  size='small'
                  value={groupSize}
                  onChange={(e) => {
                    setGroupSize(e.target.value);

                    BHP_IndonesiaSpecific.group_size = e.target.value;
                    setBHP_IndonesiaSpecific({ ...BHP_IndonesiaSpecific });

                    // clearResponse();

                    addToPendingTasks([id]);
                  }}
                  sx={{ fontSize: 12, height: 32, width: '170px', minWidth: 170 }}
                  fullWidth
                  disabled={loadingStatus[id]}
                >
                  {
                    getGroupSizesOptions()?.map(group_size => (
                      <MenuItem key={group_size} value={group_size} sx={{ fontSize: 12 }}>{group_size}</MenuItem>
                    ))
                  }

                </Select>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', minHeight: 32 }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>MHD Loading</Typography>
                <Typography fontSize={13} sx={{ color: '#1565c0', ml: 2 }}>{getDisplayValue('MHD Loading')}</Typography>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', minHeight: 32 }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Group Size Discount</Typography>
                <Typography fontSize={13} sx={{ color: '#1565c0', ml: 2 }}>{getDisplayValue('Group Size Discount')}</Typography>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Area Of Coverage</Typography>
                <Select
                  size='small'
                  value={specificAreaOfCoverage[id]}
                  onChange={(e) => {
                    specificAreaOfCoverage[id] = e.target.value;
                    setSpecificAreaOfCoverage({ ...specificAreaOfCoverage });

                    // clearResponse();

                    addToPendingTasks([id]);
                  }}
                  sx={{ fontSize: 12, height: 32, width: '170px', minWidth: 170 }}
                  fullWidth
                  disabled={loadingStatus[id]}
                >
                  {
                    specific_area_of_coverages && specific_area_of_coverages.map(area_of_coverage => (
                      <MenuItem key={area_of_coverage} value={area_of_coverage} sx={{ fontSize: 12 }}>{area_of_coverage}</MenuItem>
                    ))
                  }

                </Select>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Currency</Typography>
                <Select
                  size='small'
                  value={specificCurrency[id]}
                  onChange={(e) => {
                    specificCurrency[id] = e.target.value;
                    setSpecificCurrency({ ...specificCurrency });

                    // clearResponse();

                    setDeductibles(prev => {
                      return {
                        ...prev,
                        [id]: getSafe(() => appConfig.content.deductibles?.[id]?.[specificCurrency?.[id]]?.[0])
                      };
                    });


                    addToPendingTasks([id]);
                  }}
                  sx={{ fontSize: 12, height: 32, width: '170px', minWidth: 170 }}
                  fullWidth
                  disabled={loadingStatus[id]}
                >
                  {
                    currencies && currencies.map(currency => (
                      <MenuItem key={currency} value={currency} sx={{ fontSize: 12 }}>{currency}</MenuItem>
                    ))
                  }

                </Select>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Payment Frequency</Typography>
                <Select
                  size='small'
                  value={specificPaymentFrequency[id]}
                  onChange={(e) => {
                    specificPaymentFrequency[id] = e.target.value;
                    setSpecificPaymentFrequency({ ...specificPaymentFrequency });

                    addToPendingTasks([id]);
                  }}
                  sx={{ fontSize: 12, height: 32, width: '170px', minWidth: 170 }}
                  fullWidth
                  disabled={loadingStatus[id]}
                >
                  {
                    ["Annually", "Semi Annually", "Quarterly", "Monthly"].map(payment_frequency => (
                      <MenuItem key={payment_frequency} value={payment_frequency} sx={{ fontSize: 12 }}>{payment_frequency}</MenuItem>
                    ))
                  }

                </Select>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Renewal/Further Discount</Typography>
                <PercentInput
                  value={discounts[id]}
                  onCommit={(value) => setDiscounts(prev => ({ ...prev, [id]: value }))}
                />
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Renewal/Further Loading</Typography>
                <PercentInput
                  value={loadings[id]}
                  onCommit={(value) => setLoadings(prev => ({ ...prev, [id]: value }))}
                />
              </Box>
            </Box>
          </Box>




          <div style={{ display: 'flex', alignItems: 'start', justifyContent: 'end', width: '100%', marginBottom: 7, marginTop: 14 }}>
            <CopyExcelDataButton
              elementId='table-bhp-indonesia-rates'
              style={{
                marginRight: 7, fontSize: 11, padding: '2px 8px', minHeight: 0
              }}
              sx={{ '& .MuiSvgIcon-root': { fontSize: 14 } }}
            />
            <CopyImageButton
              elementId='table-bhp-indonesia-rates'
              setShowImageCopy={setShowImageCopy}
              style={{ fontSize: 11, padding: '2px 8px', minHeight: 0 }}
              sx={{ '& .MuiSvgIcon-root': { fontSize: 14 } }}
            />
          </div>
          <TableContainer component={Paper} style={{ width: 'auto', overflowX: 'auto' }}>
            <Table id='table-bhp-indonesia-rates' size='small' style={{ background: '#fff', width: `calc(100% + ${clients.length > 5 ? clients.length - 5 : 0} * 75px)` }} >
              <TableHead>
                <TableRow className='row-not-included-in-excel' style={{ background: '#0076bd', color: '#fff' }}>
                  <TableCell />
                  {
                    clients.map((client, idx) => {
                      return (
                        <TableCell key={idx}>
                          {
                            <div><FormControlLabel style={{ color: '#fff' }} control={<Checkbox checked={checkAddOnPerClient('maternity', idx)} onChange={() => handleAddOnPerClientChange('maternity', idx)} style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, fontSize: 10, color: '#fff' }} size="small" />} label="With Maternity" /></div>
                          }
                        </TableCell>
                      );
                    })
                  }

                  <TableCell />
                </TableRow>
                <TableRow style={{ backgroundColor: '#0c1b4e' }}>
                  <TableCell color="rgb(255, 255, 255)" colSpan={1} style={{ width: 200, fontWeight: 600, color: 'rgb(255, 255, 255)' }}>Plan</TableCell>
                  {
                    clients.map((client, idx) => {
                      if (client.full_name.trim() === '') {
                        return <TableCell color="rgb(255, 255, 255)" style={{ width: 200, fontWeight: 600, color: 'rgb(255, 255, 255)' }} key={idx}>_</TableCell>
                      }

                      return <TableCell color="rgb(255, 255, 255)" style={{ width: 200, fontWeight: 600, color: 'rgb(255, 255, 255)' }} key={idx}><div>{client.full_name} ({client.age})</div><div>{client.country_of_residence}</div>  </TableCell>
                    })
                  }
                  <TableCell color="rgb(255, 255, 255)" style={{ fontWeight: 600, color: 'rgb(255, 255, 255)' }}>Subtotal</TableCell>
                </TableRow>


              </TableHead>
              {
                (<TableBody>
                  {
                    selectedPlans.includes('bhp_indonesia_select') &&
                    <TableRow>
                      <TableCellText content='Select' style={{ width: 200, minWidth: 200 }} />
                      {
                        clients.map((client, idx) => {
                          return <TableCellRate
                            key={client.uid}
                            rate={getRate(idx, 'select')}
                            currency={getCurrency()}
                            isLoading={loadingStatus[id]}
                          />;
                        })
                      }

                      <TableCellRateSubtotalPerPlan
                        computedRates={getComputedRatesMemo()}
                        planName='select'
                        currency={getCurrency()}
                        isLoading={loadingStatus[id]}
                        specificCurrency={specificCurrency[id]}
                      />
                    </TableRow>
                  }



                  {
                    selectedPlans.includes('bhp_indonesia_premier') &&
                    <TableRow>
                      <TableCellText content='Premier' style={{ width: 200, minWidth: 200 }} />
                      {
                        clients.map((client, idx) => {
                          return <TableCellRate
                            key={client.uid}
                            rate={getRate(idx, checkAddOnPerClient('maternity', idx) ? 'premier_with_maternity' : 'premier')}
                            currency={getCurrency()}
                            isLoading={loadingStatus[id]}
                          />;
                        })
                      }

                      {/* <TableCellRateSubtotalPerPlan
                        computedRates={getComputedRatesMemo()}
                        planName={checkAddOnPerClient('maternity', 0) ? 'premier_with_maternity' : 'premier'}
                        currency={getCurrency()}
                        isLoading={loadingStatus[id]}
                        specificCurrency={specificCurrency[id]}
                      /> */}
                      <TableCellRate
                        rate={getSubTotalPerPlan('premier')}
                        currency={getCurrency()}
                        isLoading={loadingStatus[id]}
                      />
                    </TableRow>
                  }



                  {
                    selectedPlans.includes('bhp_indonesia_elite') &&
                    <TableRow>
                      <TableCellText content='Elite' style={{ width: 200, minWidth: 200 }} />
                      {
                        clients.map((client, idx) => {
                          return <TableCellRate
                            key={client.uid}
                            rate={getRate(idx, checkAddOnPerClient('maternity', idx) ? 'elite_with_maternity' : 'elite')}
                            currency={getCurrency()}
                            isLoading={loadingStatus[id]}
                          />;
                        })
                      }

                      {/* <TableCellRateSubtotalPerPlan
                        computedRates={getComputedRatesMemo()}
                        planName={checkAddOnPerClient('maternity', 0) ? 'elite_with_maternity' : 'elite'}
                        currency={getCurrency()}
                        isLoading={loadingStatus[id]}
                        specificCurrency={specificCurrency[id]}
                      /> */}
                      <TableCellRate
                        rate={getSubTotalPerPlan('elite')}
                        currency={getCurrency()}
                        isLoading={loadingStatus[id]}
                      />
                    </TableRow>
                  }

                  {
                    selectedPlans.includes('bhp_indonesia_ultimate') &&
                    <TableRow>
                      <TableCellText content='Ultimate' style={{ width: 200, minWidth: 200 }} />
                      {
                        clients.map((client, idx) => {
                          return <TableCellRate
                            key={client.uid}
                            rate={getRate(idx, checkAddOnPerClient('maternity', idx) ? 'ultimate_with_maternity' : 'ultimate')}
                            currency={getCurrency()}
                            isLoading={loadingStatus[id]}
                          />;
                        })
                      }

                      {/* <TableCellRateSubtotalPerPlan
                        computedRates={getComputedRatesMemo()}
                        planName={checkAddOnPerClient('maternity', 0) ? 'ultimate_with_maternity' : 'ultimate'}
                        currency={getCurrency()}
                        isLoading={loadingStatus[id]}
                        specificCurrency={specificCurrency[id]}
                      /> */}
                      <TableCellRate
                        rate={getSubTotalPerPlan('ultimate')}
                        currency={getCurrency()}
                        isLoading={loadingStatus[id]}
                      />
                    </TableRow>
                  }

                  {
                    (selectedPlans.includes('bhp_indonesia_dental_1') || selectedPlans.includes('bhp_indonesia_dental_optical_2') || selectedPlans.includes('bhp_indonesia_dental_optical_3')) &&
                    <TableRow sx={{ backgroundColor: '#ffffff' }}>
                      <TableCell colSpan={clients.length + 2} sx={{ fontWeight: 600, background: '#fff' }}>Optional</TableCell>
                    </TableRow>
                  }

                  {
                    selectedPlans.includes('bhp_indonesia_dental_1') &&
                    <TableRow>
                      <TableCellText content='Dental 1' style={{ width: 200, minWidth: 200 }} />
                      {
                        clients.map((client, idx) => {
                          return <TableCellRate
                            key={client.uid}
                            rate={getRate(idx, 'dental_1')}
                            currency={getCurrency()}
                            isLoading={loadingStatus[id]}
                            fractionDigits={0}
                          />;
                        })
                      }

                      <TableCellRateSubtotalPerPlan
                        computedRates={getComputedRatesMemo()}
                        planName='dental_1'
                        currency={getCurrency()}
                        isLoading={loadingStatus[id]}
                        specificCurrency={specificCurrency[id]}
                        fractionDigits={0}
                      />
                    </TableRow>
                  }

                  {
                    selectedPlans.includes('bhp_indonesia_dental_optical_2') &&
                    <TableRow>
                      <TableCellText content='Dental & Optical 2' style={{ width: 200, minWidth: 200 }} />
                      {
                        clients.map((client, idx) => {
                          return <TableCellRate
                            key={client.uid}
                            rate={getRate(idx, 'dental_optical_2')}
                            currency={getCurrency()}
                            isLoading={loadingStatus[id]}
                            fractionDigits={0}
                          />;
                        })
                      }

                      <TableCellRateSubtotalPerPlan
                        computedRates={getComputedRatesMemo()}
                        planName='dental_optical_2'
                        currency={getCurrency()}
                        isLoading={loadingStatus[id]}
                        specificCurrency={specificCurrency[id]}
                        fractionDigits={0}
                      />
                    </TableRow>
                  }

                  {
                    selectedPlans.includes('bhp_indonesia_dental_optical_3') &&
                    <TableRow>
                      <TableCellText content='Dental & Optical 3' style={{ width: 200, minWidth: 200 }} />
                      {
                        clients.map((client, idx) => {
                          return <TableCellRate
                            key={client.uid}
                            rate={getRate(idx, 'dental_optical_3')}
                            currency={getCurrency()}
                            isLoading={loadingStatus[id]}
                            fractionDigits={0}
                          />;
                        })
                      }

                      <TableCellRateSubtotalPerPlan
                        computedRates={getComputedRatesMemo()}
                        planName='dental_optical_3'
                        currency={getCurrency()}
                        isLoading={loadingStatus[id]}
                        specificCurrency={specificCurrency[id]}
                        fractionDigits={0}
                      />
                    </TableRow>
                  }


                  {/*
                  {
                    assistanceCovers.evacuation &&
                    <TableRow>
                      <TableCellText content='Evacuation' style={{ width: 200, minWidth: 200 }} />
                      {
                        clients.map((client, idx) => {
                          return <TableCellRate
                            key={client.uid}
                            rate={getRate(idx, 'evacuation')}
                            currency={getCurrency()}
                            isLoading={loadingStatus[id]}
                          />;
                        })
                      }

                      <TableCellRateSubtotalPerPlan
                        computedRates={getComputedRatesMemo()}
                        planName='evacuation'
                        currency={getCurrency()}
                        isLoading={loadingStatus[id]}
                        specificCurrency={specificCurrency[id]}
                      />
                    </TableRow>
                  }



                  {
                    assistanceCovers.repatriation &&
                    <TableRow>
                      <TableCellText content='Repatriation' style={{ width: 200, minWidth: 200 }} />
                      {
                        clients.map((client, idx) => {
                          return <TableCellRate
                            key={client.uid}
                            rate={getRate(idx, 'repatriation')}
                            currency={getCurrency()}
                            isLoading={loadingStatus[id]}
                          />;
                        })
                      }

                      <TableCellRateSubtotalPerPlan
                        computedRates={getComputedRatesMemo()}
                        planName='repatriation'
                        currency={getCurrency()}
                        isLoading={loadingStatus[id]}
                        specificCurrency={specificCurrency[id]}
                      />
                    </TableRow>
                  } */}
                </TableBody>
                )
              }
            </Table>

          </TableContainer>

          <NotesDisplay appConfig={appConfig} insurerId={id} />

          <RatesVersionSelect
            insurer={id}
            label="Rates Version"
            insurerRates={insurerRates}
            selectedRatesVersion={selectedRatesVersion}
            setSelectedRatesVersion={setSelectedRatesVersion}
            disabled={loadingStatus[id]}
            handleFetchAppConfig={handleFetchAppConfig}
            onChange={() => setShowRefreshNow(true)}
          />

        </Box>


      </Paper>
    </Box>
  );
});

export default BHP_Indonesia_Rates;